import ConnectWorkers from './ConnectWorkers';
import Otp from './Otp';
import OtpChallenge from './OtpChallenge';
import OtpRemove from './OtpRemove';
import OtpLogin from './OtpLogin';

const modalsIndex: Record<string, { Component: React.VFC<{ close(): void }>, title: string }> = {
  ConnectWorkers: {
    Component: ConnectWorkers,
    title: 'Connect Workers',
  },
  Otp: {
    Component: Otp,
    title: 'Enable Two-Factor Authentication',
  },
  OtpChallenge: {
    Component: OtpChallenge,
    title: 'Verify Two-Factor Authentication',
  },
  OtpRemove: {
    Component: OtpRemove,
    title: 'Disable Two-Factor Authentication',
  },
  OtpLogin: {
    Component: OtpLogin,
    title: 'Enter One-Time Password to Log In',
  },
};

export default modalsIndex;